<div [attr.data-qa-id]="data().dataQaId">
    <div class="nova__dialog__toolbar">
        <div class="nova__dialog__toolbar__title">
            {{data().title}}
        </div>
    </div>
    <div mat-dialog-content class="nova__dialog__content">
        @if (data().infoText) {
        <div class="resolve-disputes-dialog-text">
            {{ data().infoText }}
        </div>
        }
        <textarea class="mb-3 comment" rows="5" placeholder="Comment" [ngModel]="comment()" (ngModelChange)="comment.set($event)"></textarea>

        <div class="w-850">
            <nova-upload-attachments [attachments]="attachments()" [isTitleClickable]="false" [fileColumnNeeded]="true"
                [isTitleEditable]="true" (selectedFiles)="onSelectedFiles($event)"
                (removedFile)="onRemovedFile($event)"></nova-upload-attachments>
        </div>
    </div>

    <mat-dialog-actions>
        <button class="mat-button invoice-button invoice-button__primary" mat-raised-button (click)="close(comment())"
            [disabled]="!comment() || comment().length < 2" [attr.data-qa-id]="data().dataQaId + '_continue_button'">
            CONTINUE
        </button>
        <button mat-button (click)="close()" class="mat-button invoice-button invoice-button__default"
            [attr.data-qa-id]="data().dataQaId + '_cancel_button'">
            CANCEL
        </button>
    </mat-dialog-actions>
</div>